import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { Menu } from '../../shared/menu/menu.model';
import { FullMenuService } from '../full-menu.service';

@Component({
  selector: 'app-full-menu-order',
  templateUrl: './full-menu-order.component.html',
  styleUrls: ['./full-menu-order.component.css'],

})


export class FullMenuOrderComponent implements OnInit {

  @Input() menu: Menu;
  @Output() newMenu: EventEmitter<Menu> = new EventEmitter<Menu>();

  selectedSort: string;
  isOrder: boolean;
 
  constructor(private translate: TranslateService, private route : Router, private fullMenuService:FullMenuService) {}

  ngOnInit() {
    this.selectedSort =  'views';
    this.fullMenuService.getSortType().subscribe( (sortType: string) => {
      this.selectedSort = sortType;
    })
  }

  ngOnChanges() {
    if (this.menu && !this.isOrder) {
      this.isOrder= true;
    }
  }

  sortMenuBy(sortType: string) {
    this.fullMenuService.setSortType(sortType);
  }
}
